import { getEnvironment } from 'helpers/getEnvironment'
const KEYS = {
  DEV: 'default/2563a02d-07ac-48e3-af95-79d1721798fe/Sxr9n8btUlIkcha38dpHcTkbOheYMW*wpwcJKfIltV2VcC2Othr',
  TEST: 'default/2563a02d-07ac-48e3-af95-79d1721798fe/Sxr9n8btUlIkcha38dpHcTkbOheYMW*wpwcJKfIltV2VcC2Othr',
  PREPROD: 'default/2563a02d-07ac-48e3-af95-79d1721798fe/Sxr9n8btUlIkcha38dpHcTkbOheYMW*wpwcJKfIltV2VcC2Othr',
  PROD: 'default/48e3a549-7305-4853-993b-878b4ccf96e0/Sxr9n8btUlIkcha38dpHcTkbOheYMW*wpwcJKfIltV2VcC2Othr'
}
export const getFeatureHubClientId = () => {
  const env = getEnvironment()
  return KEYS[env]
}